import { useState as v, useRef as d, useEffect as u, useCallback as f } from "react";
import { n as m } from "./noop-ClDc6zv4.js";
const p = {
  box: "content-box"
}, R = (s, i = p) => {
  const { box: n } = i, [o, b] = v(null), r = d(s);
  u(() => {
    r.current = s;
  });
  const t = f(
    (...e) => {
      var c;
      (c = r.current) == null || c.call(r, ...e);
    },
    []
  );
  return u(() => {
    if (o) {
      const e = new ResizeObserver(t);
      return e.observe(o, { box: n }), () => {
        e.disconnect();
      };
    }
    return m;
  }, [o, t, n]), [f((e) => {
    b(e);
  }, [])];
};
export {
  R as u
};
//# sourceMappingURL=use-resize-observer-C4bVmnEB.js.map
